(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[649],{

/***/ 6067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* reexport */ HoneyPot_HoneyPot; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/HoneyPot/HoneyPot.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var HoneyPot = function HoneyPot(_ref) {
  var register = _ref.register,
      _onChange = _ref.onChange;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "absolute -left-[500px]",
    "aria-hidden": "true",
    style: {
      zIndex: -1
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
      htmlFor: "user_code"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread({
      type: "text",
      id: "user_code",
      name: "user_code",
      autoComplete: "off",
      placeholder: "User Code"
    }, register('user_code', {
      onChange: function onChange(e) {
        return _onChange(e);
      }
    })))]
  });
};

/* harmony default export */ var HoneyPot_HoneyPot = (HoneyPot);
;// CONCATENATED MODULE: ./components/HoneyPot/index.ts


/***/ }),

/***/ 4425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _components_Contexts_LocaleContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5314);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);





var ErrorModal = function ErrorModal(_ref) {
  var show = _ref.show,
      onClose = _ref.onClose,
      children = _ref.children;

  var _useLocale = (0,_components_Contexts_LocaleContext__WEBPACK_IMPORTED_MODULE_0__/* .useLocale */ .b)(),
      lang = _useLocale.lang;

  if (!show) return null;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    className: "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
      className: "bg-white rounded-xl shadow-lg max-w-md w-full p-8 relative animate-fade-in",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", {
        "aria-label": "Close",
        className: "absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-2xl",
        onClick: onClose,
        children: "\xD7"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "flex flex-col items-center",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          className: "mb-4",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", {
            width: "48",
            height: "48",
            fill: "none",
            viewBox: "0 0 24 24",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("circle", {
              cx: "12",
              cy: "12",
              r: "10",
              fill: "#f87171"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
              d: "M12 7v5m0 4h.01",
              stroke: "#fff",
              strokeWidth: "2",
              strokeLinecap: "round"
            })]
          })
        }), children, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", {
          className: "mt-2 px-6 py-2 rounded bg-blue-600 text-white font-medium hover:bg-blue-700 transition",
          onClick: onClose,
          children: lang === 'en' ? 'Close' : 'ปิด'
        })]
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ErrorModal);

/***/ }),

/***/ 3886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ culture_career; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./components/_OldDesign/header.tsx + 1 modules
var header = __webpack_require__(6627);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./styles/Content.module.scss
var Content_module = __webpack_require__(8369);
var Content_module_default = /*#__PURE__*/__webpack_require__.n(Content_module);
// EXTERNAL MODULE: ./styles/culture.module.scss
var culture_module = __webpack_require__(1559);
var culture_module_default = /*#__PURE__*/__webpack_require__.n(culture_module);
// EXTERNAL MODULE: ./node_modules/react-multi-carousel/lib/styles.css
var styles = __webpack_require__(6494);
// EXTERNAL MODULE: ./models/conent.ts
var conent = __webpack_require__(3290);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js + 1 modules
var index_es = __webpack_require__(9603);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9417);
;// CONCATENATED MODULE: ./node_modules/react-loading-skeleton/dist/index.js
'use client';


/**
 * @internal
 */
const SkeletonThemeContext = react.createContext({});

/* eslint-disable react/no-array-index-key */
const defaultEnableAnimation = true;
// For performance & cleanliness, don't add any inline styles unless we have to
function styleOptionsToCssProperties({ baseColor, highlightColor, width, height, borderRadius, circle, direction, duration, enableAnimation = defaultEnableAnimation, customHighlightBackground, }) {
    const style = {};
    if (direction === 'rtl')
        style['--animation-direction'] = 'reverse';
    if (typeof duration === 'number')
        style['--animation-duration'] = `${duration}s`;
    if (!enableAnimation)
        style['--pseudo-element-display'] = 'none';
    if (typeof width === 'string' || typeof width === 'number')
        style.width = width;
    if (typeof height === 'string' || typeof height === 'number')
        style.height = height;
    if (typeof borderRadius === 'string' || typeof borderRadius === 'number')
        style.borderRadius = borderRadius;
    if (circle)
        style.borderRadius = '50%';
    if (typeof baseColor !== 'undefined')
        style['--base-color'] = baseColor;
    if (typeof highlightColor !== 'undefined')
        style['--highlight-color'] = highlightColor;
    if (typeof customHighlightBackground === 'string')
        style['--custom-highlight-background'] = customHighlightBackground;
    return style;
}
function Skeleton({ count = 1, wrapper: Wrapper, className: customClassName, containerClassName, containerTestId, circle = false, style: styleProp, ...originalPropsStyleOptions }) {
    var _a, _b, _c;
    const contextStyleOptions = react.useContext(SkeletonThemeContext);
    const propsStyleOptions = { ...originalPropsStyleOptions };
    // DO NOT overwrite style options from the context if `propsStyleOptions`
    // has properties explicity set to undefined
    for (const [key, value] of Object.entries(originalPropsStyleOptions)) {
        if (typeof value === 'undefined') {
            delete propsStyleOptions[key];
        }
    }
    // Props take priority over context
    const styleOptions = {
        ...contextStyleOptions,
        ...propsStyleOptions,
        circle,
    };
    // `styleProp` has the least priority out of everything
    const style = {
        ...styleProp,
        ...styleOptionsToCssProperties(styleOptions),
    };
    let className = 'react-loading-skeleton';
    if (customClassName)
        className += ` ${customClassName}`;
    const inline = (_a = styleOptions.inline) !== null && _a !== void 0 ? _a : false;
    const elements = [];
    const countCeil = Math.ceil(count);
    for (let i = 0; i < countCeil; i++) {
        let thisStyle = style;
        if (countCeil > count && i === countCeil - 1) {
            // count is not an integer and we've reached the last iteration of
            // the loop, so add a "fractional" skeleton.
            //
            // For example, if count is 3.5, we've already added 3 full
            // skeletons, so now we add one more skeleton that is 0.5 times the
            // original width.
            const width = (_b = thisStyle.width) !== null && _b !== void 0 ? _b : '100%'; // 100% is the default since that's what's in the CSS
            const fractionalPart = count % 1;
            const fractionalWidth = typeof width === 'number'
                ? width * fractionalPart
                : `calc(${width} * ${fractionalPart})`;
            thisStyle = { ...thisStyle, width: fractionalWidth };
        }
        const skeletonSpan = (react.createElement("span", { className: className, style: thisStyle, key: i }, "\u200C"));
        if (inline) {
            elements.push(skeletonSpan);
        }
        else {
            // Without the <br />, the skeleton lines will all run together if
            // `width` is specified
            elements.push(react.createElement(react.Fragment, { key: i },
                skeletonSpan,
                react.createElement("br", null)));
        }
    }
    return (react.createElement("span", { className: containerClassName, "data-testid": containerTestId, "aria-live": "polite", "aria-busy": (_c = styleOptions.enableAnimation) !== null && _c !== void 0 ? _c : defaultEnableAnimation }, Wrapper
        ? elements.map((el, i) => react.createElement(Wrapper, { key: i }, el))
        : elements));
}

function SkeletonTheme({ children, ...styleOptions }) {
    return (React.createElement(SkeletonThemeContext.Provider, { value: styleOptions }, children));
}



// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./utils/translate.ts
var translate = __webpack_require__(954);
// EXTERNAL MODULE: ./components/_OldDesign/content.tsx + 1 modules
var content = __webpack_require__(3714);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./utils/gtm.ts
var gtm = __webpack_require__(5834);
// EXTERNAL MODULE: ./components/_OldDesign/OldLayout.tsx + 1 modules
var OldLayout = __webpack_require__(4990);
// EXTERNAL MODULE: ./components/Contexts/LocaleContext.tsx
var LocaleContext = __webpack_require__(5314);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-in-view.mjs + 3 modules
var use_in_view = __webpack_require__(7037);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/Common/index.ts + 2 modules
var Common = __webpack_require__(4565);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(4487);
// EXTERNAL MODULE: ./components/shared/ErrorModal.tsx
var ErrorModal = __webpack_require__(4425);
// EXTERNAL MODULE: ./node_modules/react-cloudflare-turnstile/dist/index.js
var dist = __webpack_require__(9807);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./components/HoneyPot/index.ts + 1 modules
var HoneyPot = __webpack_require__(6067);
// EXTERNAL MODULE: ./utils/validation.ts
var validation = __webpack_require__(1672);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./pages/culture-career.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
































var DEFAULT_MESSAGE_TH = /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "text-lg font-semibold text-center text-red-600 mb-2",
    children: "\u0E40\u0E01\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14"
  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "text-center text-gray-700 mb-4",
    children: ["\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E41\u0E2D\u0E14\u0E21\u0E34\u0E19\u0E42\u0E14\u0E22\u0E15\u0E23\u0E07\u0E44\u0E14\u0E49\u0E17\u0E35\u0E48", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: "mailto:candidates@codium.co",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "font-bold text-blue-600",
        children: "candidates@codium.co"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u0E40\u0E23\u0E32\u0E02\u0E2D\u0E2D\u0E20\u0E31\u0E22\u0E43\u0E19\u0E04\u0E27\u0E32\u0E21\u0E44\u0E21\u0E48\u0E2A\u0E30\u0E14\u0E27\u0E01"]
  })]
});

var DEFAULT_MESSAGE_EN = /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "text-lg font-semibold text-center text-red-600 mb-2",
    children: "Oops! Something went wrong."
  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "text-center text-gray-700 mb-4",
    children: ["You can contact our admin directly at", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: "mailto:candidates@codium.co",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "font-bold text-blue-600",
        children: "candidates@codium.co"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "We apologize for the inconvenience."]
  })]
});

var fieldMap = {
  name: 'name',
  email: 'email',
  phoneNumber: 'phoneNumber',
  reason: 'reason'
}; // The registered name, not the CMS name. They coincide for every field the
// forms ship with today, but an editor can add one that `fieldMap` does not
// know — registering those under a shared 'none' key made two such fields
// collide and hid their errors, so a required one killed submit silently.

var fieldNameOf = function fieldNameOf(name) {
  return fieldMap[name] || name || 'none';
}; // Careers are paused: the site no longer accepts resumes and the backend has
// removed POST /api/resumes. Flip this back on together with that route.


var CAREERS_ENABLED = false;

var ESignature = function ESignature(_ref) {
  var _findContentByTitle, _findContentByTitle$i, _findContentByTitle2, _findContentByTitle$i2, _findContentByTitle3, _findContentByTitle3$, _findContentByTitle4, _findContentByTitle5, _findContentByTitle6, _findContentByTitle7, _showBenefit$image$, _contents$find$subCon, _filterContent, _findContent, _findContent2;

  var contents = _ref.contents;

  var _useState = (0,react.useState)(null),
      showReason = _useState[0],
      setShowReason = _useState[1];

  var _useState2 = (0,react.useState)(null),
      showCareer = _useState2[0],
      setShowCareer = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      showBenefit = _useState3[0],
      setShowBenefit = _useState3[1];

  var _useState4 = (0,react.useState)(null),
      showJoinTeam = _useState4[0],
      setShowJoinTeam = _useState4[1];

  var _useState5 = (0,react.useState)(null),
      skelton = _useState5[0],
      setSkelton = _useState5[1];

  var _useState6 = (0,react.useState)(null),
      upload = _useState6[0],
      setUpload = _useState6[1];

  var _useLocale = (0,LocaleContext/* useLocale */.b)(),
      lang = _useLocale.lang,
      setLang = _useLocale.setLang;

  var router = (0,next_router.useRouter)();

  var _useForm = (0,index_esm/* useForm */.cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      reset = _useForm.reset,
      errors = _useForm.formState.errors;

  var _useState7 = (0,react.useState)(null),
      resume = _useState7[0],
      setResume = _useState7[1];

  var _useState8 = (0,react.useState)(null),
      position = _useState8[0],
      setPosition = _useState8[1];

  var _useState9 = (0,react.useState)(false),
      showNoti = _useState9[0],
      setShowNoti = _useState9[1];

  var _useState10 = (0,react.useState)(false),
      showUploadResumeNoti = _useState10[0],
      setShowUploadResumeNoti = _useState10[1];

  var _useState11 = (0,react.useState)(),
      isSuccess = _useState11[0],
      setIsSuccess = _useState11[1];

  var _useState12 = (0,react.useState)(false),
      isSubmitting = _useState12[0],
      setIsSubmitting = _useState12[1];

  var _useState13 = (0,react.useState)(false),
      showErrorModal = _useState13[0],
      setShowErrorModal = _useState13[1];

  var benefitSectionRef = (0,react.useRef)();
  var isBenefitSectionInView = (0,use_in_view/* useInView */.Y)(benefitSectionRef);

  var _useState14 = (0,react.useState)(false),
      confirmRecaptcha = _useState14[0],
      setConfirmRecaptcha = _useState14[1];

  var _useState15 = (0,react.useState)(''),
      recaptchaToken = _useState15[0],
      setRecaptchaToken = _useState15[1];

  (0,react.useEffect)(function () {
    if (recaptchaToken) {
      setConfirmRecaptcha(true);
    } else {
      setConfirmRecaptcha(false);
    }
  }, [recaptchaToken]);
  (0,react.useEffect)(function () {
    var htmlElement = document.documentElement;

    if (showJoinTeam) {
      htmlElement.style.overflow = 'hidden';
    } else {
      htmlElement.style.overflow = '';
    }
  }, [showJoinTeam]);
  (0,react.useEffect)(function () {
    if (!isBenefitSectionInView && showBenefit) {
      setBenefit(null);
    }
  }, [isBenefitSectionInView]);
  (0,react.useEffect)(function () {
    var _localStorage$getItem;

    var defaultLocale = (_localStorage$getItem = localStorage.getItem('lang')) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : 'th';
    setLang(defaultLocale);
    setSkelton(true);
    var t = setTimeout(function () {
      setSkelton(false);
    }, 3000);
    return function () {
      clearTimeout(t);
    };
  }, [router]);

  var showReasonWhy = function showReasonWhy(reason) {
    setShowReason(reason);
  };

  var setShowCareerPosition = function setShowCareerPosition(career) {
    setShowCareer(showCareer === career ? null : career);
  };

  var setBenefit = function setBenefit(benefit) {
    setShowBenefit(benefit);
  };

  var findContent = function findContent(item, name) {
    if (!item) return;
    return item.find(function (item) {
      return item.name === name || item.title === name;
    });
  };

  var animation = function animation(title) {
    var text = title === null || title === void 0 ? void 0 : title.split('');
    return text === null || text === void 0 ? void 0 : text.map(function (item, i) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        "data-aos": "zoom-in",
        "data-aos-delay": "".concat(i, "50"),
        "data-aos-duration": "50",
        children: item
      }, i);
    });
  };

  var joinTeam = function joinTeam(title, item) {
    setPosition(title);
    setShowJoinTeam(item);
  };

  var closeJoinTeam = function closeJoinTeam() {
    setShowJoinTeam(null);
  };

  var handleRecaptchaChange = function handleRecaptchaChange(token) {
    setRecaptchaToken(token);
  };

  var handleSubmitForm = function handleSubmitForm(data, e) {
    e.preventDefault();

    if (data.user_code) {
      return;
    }

    if (!resume) {
      setShowUploadResumeNoti(true);
      return;
    }

    setShowUploadResumeNoti(false);

    if (!recaptchaToken) {
      alert(lang === 'en' ? 'Please confirm that you are not a robot.' : 'กรุณายืนยันว่าคุณไม่ใช่หุ่นยนต์');
      return;
    }

    setIsSubmitting(true);
    submit(data, recaptchaToken);
  };

  var submit = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data, recaptchaToken) {
      var formData;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              formData = new FormData();
              formData.append('cv', resume);
              formData.append('data', JSON.stringify({
                name: data.name,
                phoneNumber: data.phoneNumber,
                email: data.email,
                reason: data.reason,
                position: position,
                recaptcha: recaptchaToken
              }));
              _context.prev = 3;
              _context.next = 6;
              return axios_default().post("".concat(conent.be, "/api/resumes/"), formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              });

            case 6:
              (0,gtm/* GTMPageView */.o)(window.location.href, 'careerFormSubmit');
              setAlert(true);
              _context.next = 14;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](3);
              setShowErrorModal(true);
              (0,esm_exports/* captureException */.Tb)(_context.t0);

            case 14:
              _context.prev = 14;
              setResume(null);
              reset();
              setShowJoinTeam(false);
              setRecaptchaToken('');
              setIsSubmitting(false);
              return _context.finish(14);

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 10, 14, 21]]);
    }));

    return function submit(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var setAlert = function setAlert(success) {
    if (success) {
      setIsSuccess(true);
    } else {
      setIsSuccess(false);
    }

    setShowNoti(true);
    setTimeout(function () {
      setShowNoti(false);
    }, 2000);
  };

  var onFileChange = function onFileChange(event) {
    setResume(event.target.files[0]);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [showNoti ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "top-20 right-3 fixed w-1/5 z-50 border-t-4 rounded-b px-4 py-3 shadow-md ".concat(isSuccess ? 'bg-green-100 border-green-500 text-green-900' : 'bg-red-100 border-red-500 text-red-900'),
      role: "alert",
      "data-aos": "fade-left",
      "data-aos-easing": "linear",
      "data-aos-duration": "300",
      style: {
        zIndex: 99
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "font-bold",
          children: isSuccess ? 'Success' : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: ["Something wrong! ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Please try again later."]
          })
        })
      })
    }) : '', /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorModal/* default */.Z, {
      show: showErrorModal,
      onClose: function onClose() {
        return setShowErrorModal(false);
      },
      children: lang === 'en' ? DEFAULT_MESSAGE_EN : DEFAULT_MESSAGE_TH
    }), skelton ? /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton, {
      style: {
        height: 'calc(30vw + 30vh)'
      }
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "relative ".concat((Content_module_default()).header, " mt-10  h-screen bg-no-repeat bg-cover z-10"),
      style: {
        backgroundImage: "url(".concat(conent.be).concat((_findContentByTitle = (0,translate/* findContentByTitle */.pF)(contents, 'WORK HARD PLAY HARDER')) === null || _findContentByTitle === void 0 ? void 0 : (_findContentByTitle$i = _findContentByTitle.image) === null || _findContentByTitle$i === void 0 ? void 0 : _findContentByTitle$i.url)
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: "/images/career/Opacity_career.png",
        className: "absolute ".concat((Content_module_default()).backgroundFilter, " w-screen"),
        alt: "\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E15\u0E48\u0E32\u0E07\u0E46\u0E40\u0E02\u0E49\u0E32\u0E23\u0E30\u0E1A\u0E1A\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E07\u0E48\u0E32\u0E22\u0E14\u0E32\u0E22",
        loading: "lazy"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "tracking-tight flex flex-col text-white mb-10 ".concat((culture_module_default()).workHardText),
        children: (0,translate/* findContentByTitle */.pF)(contents, 'WORK HARD PLAY HARDER') ? (_findContentByTitle2 = (0,translate/* findContentByTitle */.pF)(contents, 'WORK HARD PLAY HARDER')) === null || _findContentByTitle2 === void 0 ? void 0 : _findContentByTitle2.subContent.map(function (item, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "text-8xl mb-16 z-20",
            children: animation((0,translate/* translate */.Iu)(item, 'description', lang))
          }, i);
        }) : ''
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(header/* default */.Z, {
        content: {
          title: 'Culture & Career at CODIUM - ร่วมงานกับทีมดิจิทัลเนทีฟชั้นนำ',
          content: 'ค้นพบวัฒนธรรมการทำงานที่ CODIUM และร่วมเป็นส่วนหนึ่งของทีมดิจิทัลเนทีฟชั้นนำในประเทศไทย สร้างสรรค์นวัตกรรมและเติบโตไปพร้อมกับเรา',
          image: null
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "p-16 flex flex-row mb-12 xl:mb-0 xl:px-40",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "".concat(conent.be).concat((0,translate/* findContentByTitle */.pF)(contents, 'reasons why') ? (_findContentByTitle$i2 = (0,translate/* findContentByTitle */.pF)(contents, 'reasons why').image) === null || _findContentByTitle$i2 === void 0 ? void 0 : _findContentByTitle$i2.url : ''),
          alt: (_findContentByTitle3 = (0,translate/* findContentByTitle */.pF)(contents, 'reasons why')) === null || _findContentByTitle3 === void 0 ? void 0 : (_findContentByTitle3$ = _findContentByTitle3.image) === null || _findContentByTitle3$ === void 0 ? void 0 : _findContentByTitle3$.alternativeText,
          loading: "lazy"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
          className: "text-6xl xl:text-4xl mt-24 xl:mt-12 ml-4",
          dangerouslySetInnerHTML: {
            __html: (_findContentByTitle4 = (0,translate/* findContentByTitle */.pF)(contents, 'reasons why')) === null || _findContentByTitle4 === void 0 ? void 0 : _findContentByTitle4.description
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "p-16 grid grid-cols-1 mb-8 md:grid-cols-3 xl:px-32 xl:hidden",
        children: [' ', (_findContentByTitle5 = (0,translate/* findContentByTitle */.pF)(contents, 'reasons why')) === null || _findContentByTitle5 === void 0 ? void 0 : _findContentByTitle5.subContent.map(function (item, i) {
          var _item$image$, _item$image$2;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            className: "relative mb-8",
            onClick: function onClick() {
              return showReasonWhy(item.name);
            },
            children: [showReason && showReason === item.name ? '' : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "md:hidden text-8xl font-normal absolute md:text-4xl h-8   ".concat(i % 2 === 1 ? 'top-20' : 'bottom-36'),
              children: (0,translate/* translate */.Iu)(item, 'title', lang)
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
              className: "text-4xl md:hidden font-normal text-right md:text-xl",
              children: item.name
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "grid grid-cols-2 md:grid-cols-1",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: "hidden md:block text-8xl font-normal md:text-4xl",
                  style: {
                    top: '35px'
                  },
                  children: [(0,translate/* translate */.Iu)(item, 'title', lang), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "text-4xl font-normal text-right md:text-xl",
                    children: item.name
                  })]
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "".concat(conent.be).concat(item === null || item === void 0 ? void 0 : (_item$image$ = item.image[0]) === null || _item$image$ === void 0 ? void 0 : _item$image$.url),
              alt: item === null || item === void 0 ? void 0 : (_item$image$2 = item.image[0]) === null || _item$image$2 === void 0 ? void 0 : _item$image$2.alternativeText,
              className: "m-auto h-32 mb-16 sm:mb-0",
              loading: "lazy"
            }), showReason !== item.name ? /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/images/career/arrowdown.png",
              className: "h-8 absolute right-0  ".concat(i % 2 === 0 ? 'top-16' : 'bottom-20', " animate-bounce cursor-pointer"),
              alt: "",
              loading: "lazy"
            }) : '', showReason === item.name ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              "data-aos": "fade-down",
              "data-aos-easing": "linear",
              onClick: function onClick() {
                return showReasonWhy(null);
              },
              "data-aos-duration": "100",
              className: "text-white ".concat((culture_module_default()).secondary, " rounded-lg p-16 sm:p-10 text-4xl mb-12 md:text-xl xl:absolute  xl:z-50 ").concat(lang === 'th' ? 'thai-lh' : ''),
              dangerouslySetInnerHTML: {
                __html: (0,translate/* translate */.Iu)(item, 'description', lang)
              }
            }) : '']
          }, i);
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "p-16 hidden grid-cols-1 mb-8 md:grid-cols-3 xl:grid xl:px-48",
        children: (_findContentByTitle6 = (0,translate/* findContentByTitle */.pF)(contents, 'reasons why')) === null || _findContentByTitle6 === void 0 ? void 0 : _findContentByTitle6.subContent.map(function (item, i) {
          var _item$image$3, _item$image$4;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "relative mb-16 cursor-pointer",
            onMouseOver: function onMouseOver() {
              return showReasonWhy(item.name);
            },
            onMouseLeave: function onMouseLeave() {
              return showReasonWhy(null);
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "md:hidden text-8xl font-normal absolute md:text-4xl xl:text-base h-8",
              children: (0,translate/* translate */.Iu)(item, 'title', lang)
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
              className: "text-4xl md:hidden font-normal text-right md:text-xl",
              children: item.name
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "grid relative",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
                className: "absolute",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: "hidden md:block text-8xl text-right font-normal md:text-4xl xl:text-md",
                  style: {
                    top: '35px'
                  },
                  children: [(0,translate/* translate */.Iu)(item, 'title', lang), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "text-4xl font-normal text-right md:text-xl xl:text-xl",
                    children: item.name
                  })]
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "".concat(conent.be).concat((_item$image$3 = item.image[0]) === null || _item$image$3 === void 0 ? void 0 : _item$image$3.url),
              alt: item === null || item === void 0 ? void 0 : (_item$image$4 = item.image[0]) === null || _item$image$4 === void 0 ? void 0 : _item$image$4.alternativeText,
              className: "m-auto h-32 ".concat(showReason ? 'mb-0' : ''),
              onMouseOver: function onMouseOver() {
                return showReasonWhy(item.name);
              },
              loading: "lazy"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/images/career/arrowdown.png",
              className: "h-8 absolute right-0 bottom-8 animate-bounce cursor-pointer xl:h-4",
              alt: "\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E15\u0E48\u0E32\u0E07\u0E46\u0E40\u0E02\u0E49\u0E32\u0E23\u0E30\u0E1A\u0E1A\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E07\u0E48\u0E32\u0E22\u0E14\u0E32\u0E22",
              loading: "lazy"
            }), showReason === item.name ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              "data-aos": "fade-down",
              "data-aos-easing": "linear",
              "data-aos-duration": "300",
              className: "text-white ".concat((culture_module_default()).secondary, " min-h-36 shadow-md p-8 text-4xl mb-4 rounded-lg font-light md:text-xs xl:text-xs xl:absolute xl:top-8  xl:z-50 ").concat(lang === 'th' ? 'thai-lh' : ''),
              dangerouslySetInnerHTML: {
                __html: (0,translate/* translate */.Iu)(item, 'description', lang)
              }
            }) : '']
          }, i);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        ref: benefitSectionRef,
        className: "p-16  flex flex-col ".concat((Content_module_default()).bgBlue, " justify-center text-white relative xl:px-16 xl:pt-8"),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(content/* default */.Z, {
          contents: (0,translate/* titleOnly */.rT)((0,translate/* findContentByTitle */.pF)(contents, 'OUR BENEFIT'))
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "grid grid-cols-2 lg:grid-cols-3 w-fullscreen font-light justify-center text-center xl:grid-cols-4 xl:px-36 xl:mt-8",
          children: (_findContentByTitle7 = (0,translate/* findContentByTitle */.pF)(contents, 'OUR BENEFIT')) === null || _findContentByTitle7 === void 0 ? void 0 : _findContentByTitle7.subContent.map(function (item, i) {
            var _item$image$5;

            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "mb-16 ".concat(showBenefit && 'pointer-events-none'),
              onClick: function onClick() {
                return setBenefit(item);
              },
              "data-aos": "fade-down",
              "data-aos-easing": "linear",
              "data-aos-duration": "350",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: "".concat(conent.be).concat(item.image[0].url),
                alt: item === null || item === void 0 ? void 0 : (_item$image$5 = item.image[0]) === null || _item$image$5 === void 0 ? void 0 : _item$image$5.alternativeText,
                className: "m-auto mb-16 h-32 xl:h-16 xl:m-auto xl:mb-4",
                loading: "lazy"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
                className: "text-3xl font-normal mb-8 xl:text-base xl:mb-0",
                children: (0,translate/* translate */.Iu)(item, 'title', lang)
              })]
            }, i);
          })
        })]
      }), showBenefit ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "text-3xl fixed ".concat((culture_module_default()).benefit, " shadow-sm p-24 pt-4 font-light ").concat((culture_module_default()).borderBlue, " text-center rounded-xl shadow-md z-50\n            md:hidden ").concat(lang === 'th' ? 'thai-lh' : ''),
        "data-aos": "zoom-in",
        "data-aos-easing": "linear",
        "data-aos-duration": "350",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "".concat((culture_module_default()).benefitImg, " ").concat((culture_module_default()).borderBlue),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "".concat(conent.be).concat(showBenefit.image[0].url),
            alt: showBenefit === null || showBenefit === void 0 ? void 0 : (_showBenefit$image$ = showBenefit.image[0]) === null || _showBenefit$image$ === void 0 ? void 0 : _showBenefit$image$.alternativeText,
            className: "m-auto h-24",
            loading: "lazy"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "font-normal mb-8 text-4xl mt-32",
          children: [(0,translate/* translate */.Iu)(showBenefit, 'title', lang), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "absolute right-8 top-8 cursor-pointer text-2xl",
            onClick: function onClick() {
              return setBenefit(null);
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
              icon: free_solid_svg_icons/* faTimes */.NBC
            }), " CLOSE"]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-4 text-4xl ".concat(lang === 'th' ? 'thai-lh' : ''),
          children: (0,translate/* translate */.Iu)(showBenefit, 'description', lang)
        })]
      }) : '', CAREERS_ENABLED && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(content/* default */.Z, {
          contents: (0,translate/* titleOnly */.rT)(contents === null || contents === void 0 ? void 0 : contents.find(function (item) {
            return item.name === 'CAREERS';
          }))
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("h1", {
          className: "text-center text-4xl",
          children: [' ', contents === null || contents === void 0 ? void 0 : (_contents$find$subCon = contents.find(function (item) {
            return item.title === 'CAREERS';
          }).subContent[0]) === null || _contents$find$subCon === void 0 ? void 0 : _contents$find$subCon.description]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "grid grid-col-1 mt-8 rounded-md md:grid-cols-2  xl:mb-16 xl:px-48",
          children: (_filterContent = (0,translate/* filterContent */.OC)(contents, 'job')) === null || _filterContent === void 0 ? void 0 : _filterContent.map(function (item, i) {
            var _item$image, _item$image$6;

            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "relative m-8 xl:m-4 rounded-md cursor-pointer hover:text-6xl",
              "data-aos": "fade-up",
              onClick: function onClick() {
                return setShowCareerPosition(item.title);
              },
              style: {
                backgroundImage: showCareer === item.title ? "linear-gradient(#0B273E, #095069)" : ''
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
                className: "absolute text-4xl text-white top-16 left-16 xl:top-4 xl:left-8 xl:text-2xl",
                children: (0,translate/* translate */.Iu)(item, 'title', lang)
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: "/images/career/double.svg",
                className: "absolute top-24 xl:top-12 left-8",
                alt: "\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E15\u0E48\u0E32\u0E07\u0E46\u0E40\u0E02\u0E49\u0E32\u0E23\u0E30\u0E1A\u0E1A\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E07\u0E48\u0E32\u0E22\u0E14\u0E32\u0E22",
                loading: "lazy"
              }), showCareer !== item.title ? /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: "".concat(conent.be).concat((_item$image = item.image) === null || _item$image === void 0 ? void 0 : _item$image.url),
                alt: item === null || item === void 0 ? void 0 : (_item$image$6 = item.image[0]) === null || _item$image$6 === void 0 ? void 0 : _item$image$6.alternativeText,
                className: "w-screen"
              }) : '', showCareer === item.title ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "w-100  flex flex-col justify-center mt-16 pb-16 ",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
                  className: "text-3xl text-white text-center mt-24 p-8 xl:text-xl xl:p-4 xl:mt-4",
                  children: item.description
                }), item.subContent.map(function (sub, subindex) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    "data-aos": "fade-down",
                    "data-aos-easing": "linear",
                    "data-aos-duration": "350",
                    className: "text-3xl sm:text-2xl text-white text-center font-light p-8 sm:p-5 m-8 sm:my-5 xl:m-4 xl:text-base xl:p-6 cursor-pointer ".concat((Content_module_default()).bgBlue),
                    onClick: function onClick() {
                      return joinTeam(sub.title, item);
                    },
                    children: sub.title
                  }, subindex);
                })]
              }) : '']
            }, i);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "text-3xl fixed shadow-lg font-light text-center \n             w-screen  ".concat((culture_module_default()).careerForm, " z-20 max-h-screen xl:px-12 xl:py-4 lg:pty-0 ").concat(showJoinTeam ? 'visible' : 'invisible'),
          "data-aos": "zoom-in",
          "data-aos-easing": "linear",
          "data-aos-duration": "350",
          style: {
            zIndex: 90,
            width: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.6)'
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "w-full h-full bg-white rounded-md xl:w-7/12 xl:mx-auto overflow-y-auto pb-10 mb:pb-0",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex flex-col md:flex-row-reverse justify-between md:p-8",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "pt-12 px-12 md:p-0",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "text-right cursor-pointer xl:text-xs",
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                    onClick: function onClick() {
                      return closeJoinTeam();
                    },
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                      icon: free_solid_svg_icons/* faTimes */.NBC
                    }), " CLOSE"]
                  })
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "text-5xl font-bold m-8 border-l-8 text-left border-red-400 xl:text-xl xl:m-0 lg:mt-4 pl-8",
                dangerouslySetInnerHTML: {
                  __html: (0,translate/* translate */.Iu)(findContent(contents, 'Career Forms'), 'title', lang)
                }
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "text-4xl font-normal  p-8 xl:text-lg xl:p-0",
              children: (0,translate/* translate */.Iu)(findContent(contents, 'Career Forms'), 'description', lang)
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
              className: "px-8 xl:p-0",
              onSubmit: handleSubmit(handleSubmitForm),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "grid md:grid-cols-2",
                children: (_findContent = findContent(contents, 'Career Forms')) === null || _findContent === void 0 ? void 0 : _findContent.form.map(function (item, i) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    children: item.inputType === 'text' ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "my-16 md:m-8 relative",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
                        className: "block text-left text-4xl font-medium text-gray-700 md:text-lg xl:text-sm xl:9/12",
                        children: [(0,translate/* translate */.Iu)(item, 'label', lang), ' ', item.required ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                          className: "text-red",
                          children: "*"
                        }) : '']
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread({
                        type: "text",
                        className: "focus:ring-indigo-500 focus:border-indigo-500 md:text-lg block w-full pl-7 pr-12 sm text-left border-gray-300 border my-4 p-2 rounded xl:9/12 xl:my-2 xl:text-sm",
                        id: "form-".concat(item.name),
                        name: item.name
                      }, register(fieldNameOf(item.name), _objectSpread(_objectSpread({}, (0,validation/* requiredRule */.n0)(item.required, (0,translate/* translate */.Iu)(item, 'label', lang), lang)), (0,validation/* formatRules */.jU)(item.name, lang))))), errors[fieldNameOf(item.name)] && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                        className: "text-red text-left text-3xl md:text-lg xl:text-sm -mt-2 mb-2",
                        children: errors[fieldNameOf(item.name)].message
                      })]
                    }) : ''
                  }, i);
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(HoneyPot/* HoneyPot */.m, {
                register: register,
                onChange: function onChange() {}
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "mt-4 lg:mt-0",
                children: (_findContent2 = findContent(contents, 'Career Forms')) === null || _findContent2 === void 0 ? void 0 : _findContent2.form.map(function (item, i) {
                  return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                    children: [item.inputType === 'files' ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
                        className: "block  md:m-8 text-left text-4xl font-medium text-gray-700 md:text-xl xl:text-sm xl:/12",
                        children: [(0,translate/* translate */.Iu)(item, 'label', lang), ' ', item.required ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                          className: "text-red",
                          children: "*"
                        }) : '', showUploadResumeNoti && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                          className: "text-red",
                          children: lang == 'en' ? 'Please upload your resume.' : 'กรุณาอัปโหลดเรซู่เม่'
                        })]
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        className: "mt-1 h-16  md:m-8 relative border-dashed flex border-gray-300 cursor-pointer border-2",
                        onClick: function onClick(e) {
                          return upload.click();
                        },
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                          className: "text-center m-auto text-gray-300 xl:text-base",
                          children: resume ? resume.name : 'Click to upload'
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                          type: "file",
                          ref: function ref(_ref3) {
                            return setUpload(_ref3);
                          },
                          onChange: function onChange(e) {
                            return onFileChange(e);
                          },
                          className: "focus:ring-indigo-500 focus:border-indigo-500  w-full pl-7 pr-12 sm border-gray-300 my-8 p-4 text-center xl:my-2 xl:9/12 hidden",
                          placeholder: "Click to upload",
                          accept: ".pdf"
                        })]
                      }), ' ']
                    }) : '', item.inputType === 'button' ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "mt-12 text-left text-3xl md:text-xl lg:text-lg xl:text-sm md:mx-8",
                        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                          children: [lang === 'en' ? 'Please provide only the necessary details when submitting your resume.' : 'โปรดกรอกรายละเอียดข้อมูลที่จำเป็นเท่านั้น สำหรับการส่งเรซูเม่ของคุณ', /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), lang === 'en' ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: "Ensure that you do not include sensitive personal information such as religion, ethnicity, weight, height, etc. If such information is provided, CODIUM will consider it as your consent to disclose this information to us."
                          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: "\u0E42\u0E1B\u0E23\u0E14\u0E17\u0E33\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E30\u0E1A\u0E38\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E48\u0E27\u0E19\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E2D\u0E48\u0E2D\u0E19\u0E44\u0E2B\u0E27 \u0E40\u0E0A\u0E48\u0E19 \u0E28\u0E32\u0E2A\u0E19\u0E32 \u0E40\u0E0A\u0E37\u0E49\u0E2D\u0E0A\u0E32\u0E15\u0E34 \u0E19\u0E49\u0E33\u0E2B\u0E19\u0E31\u0E01 \u0E2A\u0E48\u0E27\u0E19\u0E2A\u0E39\u0E07 \u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E19 \u0E43\u0E19\u0E01\u0E23\u0E13\u0E35\u0E17\u0E35\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E01\u0E23\u0E2D\u0E01/\u0E23\u0E30\u0E1A\u0E38\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E14\u0E31\u0E07\u0E01\u0E25\u0E48\u0E32\u0E27 CODIUM \u0E08\u0E30\u0E16\u0E37\u0E2D\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E22\u0E34\u0E19\u0E22\u0E2D\u0E21\u0E40\u0E1B\u0E34\u0E14\u0E40\u0E1C\u0E22\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E43\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E19\u0E31\u0E49\u0E19\u0E43\u0E2B\u0E49\u0E01\u0E31\u0E1A\u0E17\u0E32\u0E07 CODIUM \u0E40\u0E2D\u0E07"
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), lang === 'en' ? 'You can read more about how we protect your personal data in our' : 'โปรดอ่านรายละเอียดเกี่ยวกับการคุ้มครองข้อมูลส่วนบุคคลของคุณได้ที่นี่', ' ', /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                            href: '/privacy-policy',
                            passHref: true,
                            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                              target: "_blank",
                              className: "underline text-lightBlue hover:text-lightBlue-600",
                              children: lang === 'en' ? 'Privacy Policy.' : 'นโยบายความเป็นส่วนตัว'
                            })
                          })]
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "w-fit mx-auto py-5",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)((dist_default()), {
                          turnstileSiteKey: conent/* turnstileSiteKey */.z,
                          callback: function callback(token) {
                            return handleRecaptchaChange(token);
                          },
                          theme: "light"
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center mb-[10rem] lg:mb-6",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Common/* Button */.z, {
                          type: "submit",
                          className: "disabled:opacity-30",
                          icon: "/icons/paper_plane.svg",
                          text: isSubmitting ? lang === 'en' ? 'Sending...' : 'กำลังส่งข้อมูล...' : lang === 'en' ? 'Send' : 'ส่งข้อมูล',
                          disabled: !confirmRecaptcha || isSubmitting
                        })
                      })]
                    }) : '']
                  }, i);
                })
              })]
            })]
          })
        })]
      })]
    })]
  });
};

ESignature.getLayout = function (page) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(OldLayout/* default */.Z, {
    children: page
  });
};

var __N_SSG = true;
/* harmony default export */ var culture_career = (ESignature);

/***/ }),

/***/ 5834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ GTMPageView; }
/* harmony export */ });
var GTMPageView = function GTMPageView(url, event) {
  var pageEvent = {
    event: event,
    page: url
  }; //@ts-ignore

  window && window.dataLayer && window.dataLayer.push(pageEvent);
  return pageEvent;
};

/***/ }),

/***/ 954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IE": function() { return /* binding */ findContent; },
/* harmony export */   "Iu": function() { return /* binding */ translate; },
/* harmony export */   "OC": function() { return /* binding */ filterContent; },
/* harmony export */   "n7": function() { return /* binding */ translate2; },
/* harmony export */   "pF": function() { return /* binding */ findContentByTitle; },
/* harmony export */   "rT": function() { return /* binding */ titleOnly; }
/* harmony export */ });
var translate = function translate(item, name, lang) {
  if (!item) return;
  var translated = lang === 'en' ? item[name] : item["".concat(name, "TH")];
  return translated ? translated : item[name];
};
var titleOnly = function titleOnly(item) {
  if (!item) return;
  var titleItem = JSON.parse(JSON.stringify(item));
  delete titleItem.subContent;
  return titleItem;
};
var findContent = function findContent(data, name) {
  return data === null || data === void 0 ? void 0 : data.find(function (item) {
    return item.name === name;
  });
};
var findContentByTitle = function findContentByTitle(data, name) {
  return data === null || data === void 0 ? void 0 : data.find(function (item) {
    return item.title === name;
  });
};
var filterContent = function filterContent(data, name) {
  return data === null || data === void 0 ? void 0 : data.filter(function (item) {
    return item.name === name;
  });
};
var translate2 = function translate2(th, en, lang) {
  return lang === 'en' ? en : th;
};

/***/ }),

/***/ 1672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jU": function() { return /* binding */ formatRules; },
/* harmony export */   "n0": function() { return /* binding */ requiredRule; }
/* harmony export */ });
/* unused harmony exports EMAIL_PATTERN, PHONE_SEPARATOR_PATTERN, PHONE_PATTERN, isValidEmail, isValidPhone, emailMessage, phoneMessage */
/* harmony import */ var utils_translate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(954);

var EMAIL_PATTERN = /^\S+@\S+\.\S+$/; // Phone numbers are typed in every shape people are used to — 081-234-5678,
// (02) 123 4567, +66 81 234 5678 — so the separators are stripped before the
// digit count is checked. The value itself is never rewritten: what the user
// typed is what gets stored.

var PHONE_SEPARATOR_PATTERN = /[\s\-.()]/g;
var PHONE_PATTERN = /^\+?\d{9,15}$/;
var isValidEmail = function isValidEmail(value) {
  return EMAIL_PATTERN.test(String(value !== null && value !== void 0 ? value : '').trim());
};
var isValidPhone = function isValidPhone(value) {
  return PHONE_PATTERN.test(String(value !== null && value !== void 0 ? value : '').replace(PHONE_SEPARATOR_PATTERN, ''));
};
var emailMessage = function emailMessage(lang) {
  return (0,utils_translate__WEBPACK_IMPORTED_MODULE_0__/* .translate2 */ .n7)('รูปแบบของ Email ไม่ถูกต้อง กรุณากรอก Email ให้ถูกต้อง', 'Invalid email format. Please enter a valid email.', lang);
};
var phoneMessage = function phoneMessage(lang) {
  return (0,utils_translate__WEBPACK_IMPORTED_MODULE_0__/* .translate2 */ .n7)('รูปแบบของหมายเลขโทรศัพท์ไม่ถูกต้อง กรุณากรอกหมายเลขโทรศัพท์ให้ถูกต้อง', 'Invalid phone number format. Please enter a valid phone number.', lang);
};
var EMAIL_FIELDS = ['email'];
var PHONE_FIELDS = ['phone', 'phoneNumber', 'tel'];
/**
 * react-hook-form rules for a field, keyed by its name.
 *
 * Forms are driven by field lists that come from Strapi, so the field name is
 * the only thing available to decide what a value should look like. Returns an
 * empty object for names that need no format check, which makes it safe to
 * spread into every `register()` call.
 *
 * Phone uses `validate` rather than `pattern` because the separators have to be
 * stripped before the digits are counted, which a single regex cannot express.
 */

var formatRules = function formatRules(fieldName, lang) {
  if (EMAIL_FIELDS.includes(fieldName)) {
    return {
      validate: function validate(value) {
        return !value || isValidEmail(value) || emailMessage(lang);
      }
    };
  }

  if (PHONE_FIELDS.includes(fieldName)) {
    return {
      validate: function validate(value) {
        return !value || isValidPhone(value) || phoneMessage(lang);
      }
    };
  }

  return {};
};

/**
 * react-hook-form `required` rule with the message every form uses:
 * "กรุณากรอก <label>" / "Please enter your <label>".
 */
var requiredRule = function requiredRule(required, label, lang) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      _ref$possessive = _ref.possessive,
      possessive = _ref$possessive === void 0 ? true : _ref$possessive,
      _ref$lowercase = _ref.lowercase,
      lowercase = _ref$lowercase === void 0 ? true : _ref$lowercase;

  var text = label !== null && label !== void 0 ? label : '';
  return {
    required: {
      value: required,
      message: "".concat((0,utils_translate__WEBPACK_IMPORTED_MODULE_0__/* .translate2 */ .n7)('กรุณากรอก', possessive ? 'Please enter your' : 'Please enter', lang), " ").concat(lowercase ? text.toLowerCase() : text)
    }
  };
};

/***/ }),

/***/ 5875:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/culture-career",
      function () {
        return __webpack_require__(3886);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1559:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"workHardText":"culture_workHardText__S_Z_0","primary":"culture_primary__EMOmX","royalBlueBg":"culture_royalBlueBg__O25hR","secondary":"culture_secondary__9xEvo","danger":"culture_danger__MyQSB","colorSecondary":"culture_colorSecondary__EM_w5","colorDanger":"culture_colorDanger___YVtD","eSignatureBg":"culture_eSignatureBg__gNSNW","benefit":"culture_benefit__dgiN8","careerForm":"culture_careerForm__Kf_q3","benefitImg":"culture_benefitImg__Mjkom","borderBlue":"culture_borderBlue__nL_EX","borderBlue2":"culture_borderBlue2__QwsA_","circle":"culture_circle__Y_KLm","service":"culture_service__cY1tI"};

/***/ }),

/***/ 6494:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 7037:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ useInView; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/utils/resolve-elements.es.js
function resolveElements(elements, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : (selectorCache[elements] = document.querySelectorAll(elements));
            elements = selectorCache[elements];
        }
        else {
            elements = document.querySelectorAll(elements);
        }
    }
    else if (elements instanceof Element) {
        elements = [elements];
    }
    /**
     * Return an empty array
     */
    return Array.from(elements || []);
}



;// CONCATENATED MODULE: ./node_modules/@motionone/utils/dist/is-function.es.js
const isFunction = (value) => typeof value === "function";



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/gestures/in-view.es.js



const thresholds = {
    any: 0,
    all: 1,
};
function inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = "any" } = {}) {
    /**
     * If this browser doesn't support IntersectionObserver, return a dummy stop function.
     * Default triggering of onStart is tricky - it could be used for starting/stopping
     * videos, lazy loading content etc. We could provide an option to enable a fallback, or
     * provide a fallback callback option.
     */
    if (typeof IntersectionObserver === "undefined") {
        return () => { };
    }
    const elements = resolveElements(elementOrSelector);
    const activeIntersections = new WeakMap();
    const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
            const onEnd = activeIntersections.get(entry.target);
            /**
             * If there's no change to the intersection, we don't need to
             * do anything here.
             */
            if (entry.isIntersecting === Boolean(onEnd))
                return;
            if (entry.isIntersecting) {
                const newOnEnd = onStart(entry);
                if (isFunction(newOnEnd)) {
                    activeIntersections.set(entry.target, newOnEnd);
                }
                else {
                    observer.unobserve(entry.target);
                }
            }
            else if (onEnd) {
                onEnd(entry);
                activeIntersections.delete(entry.target);
            }
        });
    };
    const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === "number" ? amount : thresholds[amount],
    });
    elements.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/use-in-view.mjs



function useInView(ref, { root, margin, amount, once = false } = {}) {
    const [isInView, setInView] = (0,react.useState)(false);
    (0,react.useEffect)(() => {
        if (!ref.current || (once && isInView))
            return;
        const onEnter = () => {
            setInView(true);
            return once ? undefined : () => setInView(false);
        };
        const options = {
            root: (root && root.current) || undefined,
            margin,
            amount: amount === "some" ? "any" : amount,
        };
        return inView(ref.current, onEnter, options);
    }, [root, ref, margin, once]);
    return isInView;
}




/***/ }),

/***/ 29:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [976,735,859,373,60,371,774,888,179], function() { return __webpack_exec__(5875); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);